import { connect } from 'react-redux';
import Business from './business';

export default connect()(Business);
